import ExamsBulkIndex from "@/pages/tuevs/Bulk/Index";
import ComponentsForm from "@/pages/tuevs/Components/Form";
import ComponentsIndex from "@/pages/tuevs/Components/Index";
import ExamsForm from "@/pages/tuevs/Form";
import ExamsIndex from "@/pages/tuevs/Index";
import MaterialsForm from "@/pages/tuevs/Materials/Form";
import MaterialsIndex from "@/pages/tuevs/Materials/Index";
import ComplementsForm from "@/pages/tuevs/Complements/Form";
import ComplementsIndex from "@/pages/tuevs/Complements/Index";
import MethodsForm from "@/pages/tuevs/Methods/Form";
import MethodsIndex from "@/pages/tuevs/Methods/Index";
import Import from '@/pages/tuevs/Interpolador/Import'
import Index from '@/pages/tuevs/Interpolador/Index'
import Wizard from "@/pages/tuevs/Interpolador/Wizard";
import ScalesForm from "@/pages/tuevs/Scales/Form";
import ScalesIndex from "@/pages/tuevs/Scales/Index";
import TimesForm from "@/pages/tuevs/Times/Form";
import TimesIndex from "@/pages/tuevs/Times/Index";
import ExamResultsForm from "@/pages/tuevs/ExamResults/Form";
import ExamResultsIndex from "@/pages/tuevs/ExamResults/Index";

const TuevsRoutes = [
    {path: '/tuevs/component', name: 'tuevs.component', component: ComponentsIndex, meta: {permission: 'components.index'}},
    {path: '/tuevs/component/create', name: 'tuevs.component.create', component: ComponentsForm, meta: {permission: 'components.create'}},
    {path: '/tuevs/component/edit/:id', name: 'tuevs.component.edit', component: ComponentsForm, meta: {permission: 'components.edit'}},

    {path: '/tuevs/exams', name: 'tuevs.exams', component: ExamsIndex, meta: {permission: 'tuevs_exams.index'}},
    {path: '/tuevs/exams/create', name: 'tuevs.exams.create', component: ExamsForm, meta: {permission: 'tuevs_exams.create'}},
    {path: '/tuevs/exams/edit/:id', name: 'tuevs.exams.edit', component: ExamsForm, meta: {permission: 'tuevs_exams.edit'}},
    {path: '/tuevs/exams_bulk', name: 'tuevs.exams_bulk', component: ExamsBulkIndex, meta: {permission: 'tuevs_exams.index'}},

    {path: '/tuevs/material', name: 'tuevs.material', component: MaterialsIndex, meta: {permission: 'materials.index'}},
    {path: '/tuevs/material/create', name: 'tuevs.material.create', component: MaterialsForm, meta: {permission: 'materials.create'}},
    {path: '/tuevs/material/edit/:id', name: 'tuevs.material.edit', component: MaterialsForm, meta: {permission: 'materials.edit'}},

    {path: '/tuevs/complement', name: 'tuevs.complements', component: ComplementsIndex, meta: {permission: 'complements.index'}},
    {path: '/tuevs/complement/create', name: 'tuevs.complements.create', component: ComplementsForm, meta: {permission: 'complements.create'}},
    {path: '/tuevs/complement/edit/:id', name: 'tuevs.complements.edit', component: ComplementsForm, meta: {permission: 'complements.edit'}},

    {path: '/tuevs/method', name: 'tuevs.method', component: MethodsIndex, meta: {permission: 'methods.index'}},
    {path: '/tuevs/method/create', name: 'tuevs.method.create', component: MethodsForm, meta: {permission: 'methods.create'}},
    {path: '/tuevs/method/edit/:id', name: 'tuevs.method.edit', component: MethodsForm, meta: {permission: 'methods.edit'}},

    {path: '/tuevs/scale', name: 'tuevs.scale', component: ScalesIndex, meta: {permission: 'scales.index'}},
    {path: '/tuevs/scale/create', name: 'tuevs.scale.create', component: ScalesForm, meta: {permission: 'scales.create'}},
    {path: '/tuevs/scale/edit/:id', name: 'tuevs.scale.edit', component: ScalesForm, meta: {permission: 'scales.edit'}},

    {path: '/tuevs/time', name: 'tuevs.time', component: TimesIndex, meta: {permission: 'times.index'}},
    {path: '/tuevs/time/create', name: 'tuevs.time.create', component: TimesForm, meta: {permission: 'times.create'}},
    {path: '/tuevs/time/edit/:id', name: 'tuevs.time.edit', component: TimesForm, meta: {permission: 'times.edit'}},

    {path: '/tuevs/exam_result', name: 'tuevs.examresult', component: ExamResultsIndex, meta: {permission: 'examresult.index'}},
    {path: '/tuevs/exam_result/create', name: 'tuevs.examresult.create', component: ExamResultsForm, meta: {permission: 'examresult.create'}},
    {path: '/tuevs/exam_result/edit/:id', name: 'tuevs.examresult.edit', component: ExamResultsForm, meta: {permission: 'examresult.edit'}},

    { name: 'tuevs.index', path: '/tuevs', component: Index, meta: {perfil: 'root'}},
    { name: 'tuevs.import', path: '/tuevs/import', component: Import, meta: {perfil: 'root'}},

    { name: 'tuevs.wizard', path: '/tuevs/import/wizard', component: Wizard, meta: {perfil: 'root'}},
];

export default TuevsRoutes;
